
type AuthInteractionRequest = { reason: string; scopes: string[] };

let pending: AuthInteractionRequest | null = null;
let listeners: Array<() => void> = [];

export function setAuthInteractionRequired(req: AuthInteractionRequest) {
  // Only keep one pending request — prevents multiple redirects
  if (!pending) {
    pending = req;
    // Notify any subscribed components (e.g. AuthGate) so they re-run
    listeners.forEach((fn) => fn());
  }
}

export function getAndClearAuthInteractionRequired(): AuthInteractionRequest | null {
  const r = pending;
  pending = null;
  return r;
}

/**
 * Subscribe to auth-interaction-required signals.
 * Returns an unsubscribe function.
 */
export function onAuthInteractionRequired(cb: () => void): () => void {
  listeners.push(cb);
  return () => {
    listeners = listeners.filter((fn) => fn !== cb);
  };
}
